import { DATE_FORMAT } from "@/shared/common/constants";
import type { GroupedHistory, THistoryItem } from "@/shared/common/types";
import { EmptyOrErrorContent } from "@/shared/components";
import { HistoryItem } from "@/shared/components/HistoryItem";
import { formatDate } from "@/shared/helpers";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props<T extends THistoryItem> {
  isFetching: boolean;
  historyList: GroupedHistory<T>[]
}

export const HistoryDetail = <T extends THistoryItem>({
  isFetching,
  historyList,
}: Props<T>) => {

  return (
    <div className="pt-20 detail-history">
      {isFetching ? (
        <div
          className="full-width flexbox justify-content--center align-items--center loader-wrapper">
          <Spinner isFullScreen={false} size="small"/>
        </div>
      ) : (
        <>
          {historyList.length ? (
            historyList.map((history, i) => (
              <div className="detail-history-content" key={history?.creationDate}>
                <Text
                  className={`${!!i && "mt-24"} pb-12 history-date`}
                  type="secondary"
                  size="medium"
                >
                  {formatDate(history.creationDate, DATE_FORMAT.DD_MMM_YYYY)}
                </Text>
                {history.transactions.map((transaction, index) => (
                  <div key={`${history?.creationDate}-${index}`}>
                    <HistoryItem
                      {...transaction}
                      isLast={
                        i === historyList.length - 1 && index === history.transactions.length - 1
                      }
                    />
                  </div>
                ))}
              </div>
            ))) : (
            <EmptyOrErrorContent isShowButton={false}/>
          )}
        </>
      )}
    </div>
  );
};
